// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PageTitleCount from "@sc/App/Components/Common/PageTitleCount";
import React from "react";

export interface CartTitleStyles {
    container?: InjectableCss;
    pageTitle?: TypographyProps;
    productCountText?: TypographyProps;
}

export const cartTitleStyles: CartTitleStyles = {};

const styles = cartTitleStyles;
export const CartTitle = () => {
    const cart = useAppSelector(state => getCurrentCartState(state).value);

    const totalItemCount = cart?.cartLines?.length || 0;
    return <PageTitleCount countNumber={totalItemCount} countName="Item" />;
};
const widgetModule: WidgetModule = {
    component: CartTitle,
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        displayName: "Cart Title And Count",
    },
};
export default widgetModule;
